/**
 * Chatwoot product identifier
 *
 * Backend product key passed to `getChatwootConfig` and `getChatwootIdentifierHash` for the
 * dedicated onboarding support inbox.
 */

/** Backend product key for the web app onboarding Chatwoot inbox. */
export const CHATWOOT_WEB_APP_ONBOARDING_PRODUCT = 'physiofit_services_webAppOnboarding' as const;
